import styled from 'styled-components';
import { Col } from '../../../components/Basic/Col/col';

export const Error = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #ff000069;
  z-index: 10;
  overflow:hidden
`;

export const ErrorText = styled(Col)`
  color:white;
  overflow:auto
`;


